import * as React from 'react';
import Chip from '@mui/material/Chip';


export default function ClickableChip({label, variant, color, cursor}) {
  

  return (
    <>
      <Chip label={label} variant={variant} color={color}  sx={{cursor}}/>
    </>
  );
}